module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-graph-7fd886fe85650e49ae019a092fff1fc9.png";